import { getConsentId } from './model/get-consent-id'
import { ConsentProviderPort } from '../ports'
import { ConsentTtlService } from './optanon-consent-ttl/consent-ttl.service'
import { OneTrust } from './model/onetrust'

export class OnetrustConsentProvider implements ConsentProviderPort {
  constructor(
    private readonly oneTrust: OneTrust,
    private readonly consentTtlService: ConsentTtlService
  ) {}

  OnConsentChanged(callback: () => void): void {
    this.oneTrust.OnConsentChanged(callback)
  }

  hasConsentBeenGiven(): boolean {
    return this.oneTrust.IsAlertBoxClosedAndValid()
  }

  getConsentId(): null | string {
    return getConsentId()
  }

  getConsentTtl(): Promise<number | undefined> {
    return this.consentTtlService.getConsentTtl()
  }
}
